module.exports = "../study/imgs/maps/Kanagawa/S8/Ecosystem/Avietchii/Kanagawa_Avietchii_HadGEM2_RCP85_Mid.png";